/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GraduatoriaBilancioDTO { 
    budget_bando?: number;
    posti_bando?: number;
    finanziato_importo?: number;
    finanziati_posti?: number;
    residuo_importo?: number;
    residuo_posti?: number;
    da_scorrimento_importo?: number;
    da_scorrimento_posti?: number;
    liberato_importo?: number;
    liberati_posti?: number;
}

